import { createFileRoute } from '@tanstack/react-router'
import EditionPhysicalMeasurements from 'Edition/components/sections/Layout/EditionPhysicalMeasurements'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/layout-measurements')({
    component: EditionPhysicalMeasurements,
})
